var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-chart",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c("canvas", {
                    ref: "chartCanvas",
                    staticClass: "cw-chart-block-canvas",
                  }),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-3",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Beschriftung")) +
                                  "\n                    "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentLabel,
                                    expression: "currentLabel",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentLabel,
                                },
                                on: {
                                  focusout: _vm.buildChart,
                                  input: function input($event) {
                                    if ($event.target.composing) return
                                    _vm.currentLabel = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "col-3",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Typ")) +
                                  "\n                    "
                              ),
                              _c("studip-select", {
                                attrs: {
                                  options: _vm.chartTypes,
                                  reduce: function reduce(chartTypes) {
                                    return chartTypes.value
                                  },
                                  clearable: false,
                                  label: "name",
                                },
                                on: {
                                  "option:selected": _vm.buildChart,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "open-indicator",
                                      fn: function fn(selectAttributes) {
                                        return [
                                          _c(
                                            "span",
                                            _vm._b(
                                              {},
                                              "span",
                                              selectAttributes,
                                              false
                                            ),
                                            [
                                              _c("studip-icon", {
                                                attrs: {
                                                  shape: "arr_1down",
                                                  size: 10,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function fn(option) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(option.name)),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "option",
                                      fn: function fn(option) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(option.name)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  139043120
                                ),
                                model: {
                                  value: _vm.currentType,
                                  callback: function callback($$v) {
                                    _vm.currentType = $$v
                                  },
                                  expression: "currentType",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button add",
                          on: {
                            click: _vm.addItem,
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Datensatz hinzufügen")))]
                      ),
                      _vm._v(" "),
                      _vm.currentContent.length > 0
                        ? _c(
                            "courseware-tabs",
                            {
                              attrs: {
                                setSelected: _vm.setItemTab,
                              },
                              on: {
                                selectTab: function selectTab($event) {
                                  _vm.setItemTab =
                                    parseInt(
                                      $event.name.replace(
                                        _vm.$gettext("Datensatz") + " ",
                                        ""
                                      ),
                                      10
                                    ) - 1
                                },
                              },
                            },
                            _vm._l(_vm.currentContent, function (item, index) {
                              return _c(
                                "courseware-tab",
                                {
                                  key: index,
                                  attrs: {
                                    index: index,
                                    name:
                                      _vm.$gettext("Datensatz") +
                                      " " +
                                      (index + 1).toString(),
                                    selected: index === 0,
                                    canBeEmpty: "",
                                  },
                                },
                                [
                                  _c(
                                    "form",
                                    {
                                      staticClass: "default",
                                      on: {
                                        submit: function submit($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-1",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Wert")) +
                                              "\n                            "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.value,
                                                expression: "item.value",
                                              },
                                            ],
                                            attrs: {
                                              type: "number",
                                            },
                                            domProps: {
                                              value: item.value,
                                            },
                                            on: {
                                              change: _vm.buildChart,
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "value",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-2",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(_vm.$gettext("Farbe")) +
                                              "\n                            "
                                          ),
                                          _c("studip-select", {
                                            attrs: {
                                              options: _vm.colors,
                                              reduce: function reduce(colors) {
                                                return colors.value
                                              },
                                              label: "name",
                                              clearable: false,
                                            },
                                            on: {
                                              "option:selected": _vm.buildChart,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "open-indicator",
                                                  fn: function fn(
                                                    selectAttributes
                                                  ) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._b(
                                                          {},
                                                          "span",
                                                          selectAttributes,
                                                          false
                                                        ),
                                                        [
                                                          _c("studip-icon", {
                                                            attrs: {
                                                              shape:
                                                                "arr_1down",
                                                              size: 10,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "no-options",
                                                  fn: function fn() {
                                                    return [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            _vm.$gettext(
                                                              "Es steht keine Auswahl zur Verfügung."
                                                            )
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "selected-option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("span", {
                                                        staticClass:
                                                          "vs__option-color",
                                                        style: {
                                                          "background-color":
                                                            "rgb(" +
                                                            option.rgb +
                                                            ")",
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "option",
                                                  fn: function fn(option) {
                                                    return [
                                                      _c("span", {
                                                        staticClass:
                                                          "vs__option-color",
                                                        style: {
                                                          "background-color":
                                                            "rgb(" +
                                                            option.rgb +
                                                            ")",
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: item.color,
                                              callback: function callback($$v) {
                                                _vm.$set(item, "color", $$v)
                                              },
                                              expression: "item.color",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "col-3",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext("Bezeichnung")
                                              ) +
                                              "\n                            "
                                          ),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.label,
                                                expression: "item.label",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                            },
                                            domProps: {
                                              value: item.label,
                                            },
                                            on: {
                                              focusout: _vm.buildChart,
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "label",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.currentContent.length > 1
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "button trash",
                                              on: {
                                                click: function click($event) {
                                                  return _vm.removeItem(index)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$gettext(
                                                      "Datensatz entfernen"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum Diagramm-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }